<template>
  <div class="d-inline-block">
    <b-button
      v-bind="{ variant }"
      :class="btnClass"
      @click="$refs.modal.show()"
      data-cy="delete"
    >
      <slot>削除</slot>
    </b-button>
    <v-delete-modal ref="modal" @ok="$emit('ok')" :content="content" />
  </div>
</template>

<script>
import VDeleteModal from "./VDeleteModal.vue";

export default {
  components: {
    VDeleteModal
  },
  props: {
    variant: {
      type: String,
      default: "outline-danger"
    },
    content: {
      type: String,
      default: "本当に削除しますか？"
    },
    btnClass: String
  }
};
</script>
